import * as _ from 'underscore';
import { Formatters } from '../../codegen/Localize';
import { IDataRoleDetailInfo, IDataRoleInfo } from '../models/IDataRoleInfo';
import { IUserInfo } from '../models/IUserInfo';
import { INamedItemInfo } from '../models/resourceInfoParts';
import { DataRoleSingleValue, IDataRole, IDataRoleDetail } from '../ServerApi/types/IDataRole';
import { MapperHelper } from './MapperHelper';
import { UserMapper } from './UserMapper';

export module DataRoleMapper {

  const M = MapperHelper;

  export function map(
    serverApiDataRoles: IDataRole[],
    users: _.Dictionary<IUserInfo>,
    favoriteDataRoles: _.Dictionary<any> = {},
    projects: _.Dictionary<INamedItemInfo>,
  ): IDataRoleInfo[] {
    return _.map(serverApiDataRoles, (p: IDataRole) => {
      const drInfo: IDataRoleInfo = {
        id:                           p.id,
        name:                         p.name,
        owner:                        users[p.ownerId],
        updatedAt:                    M.toDate(p.updatedAt),
        contentType:                  'dataRole',
        project:                      projects[p.projectId],
        // TODO (TFSID 892845): un-const the next 3 items. Will be un-blocked whenever *favoriting dataRoles is enabled on server
        favorite:                     !!favoriteDataRoles[p.id],
        usageInfo:                    {
                                        favoritesTotal: 0,
                                        hitsTotal: 0,
                                        hitsLastOneMonthTotal: 0,
                                        hitsLastThreeMonthsTotal: 0,
                                        hitsLastTwelveMonthsTotal: 0,
                                      },
        usageInfoMaxValues:           {
                                        favoritesTotal: 0,
                                        hitsTotal: 0,
                                        hitsLastOneMonthTotal: 0,
                                        hitsLastThreeMonthsTotal: 0,
                                        hitsLastTwelveMonthsTotal: 0,
                                      },
      };
      return drInfo;
    });
  }

  export function mapDetail(p: IDataRoleDetail): IDataRoleDetailInfo {
    return {
      id:                           p.id,
      name:                         p.name,
      owner:                        UserMapper.mapOne(p.owner),
      updatedAt:                    M.toDate(p.updatedAt),
      contentType:                  'dataRole',
      favorite:                     p.favorite,
      values:                       p.values.sort(compareValues).map(formatValue),
      valueSource:                  p.valueSource ? {datasourceId: `${p.valueSource.datasourceId}`, fieldName: p.valueSource.fieldName} : undefined,
      dataTypes:                    p.dataType,
      description:                  p.description,
      fieldConceptUri:              p.fieldConceptUri,
      valueCount:                   p.valueCount,
    };
  }
}

// Helper functions to format and sortvalues: 
const formatValue = (value: DataRoleSingleValue) => (
  value.stringValue !== undefined ? value.stringValue :
  value.timeValue !== undefined ? Formatters.formatMediumDateTimeWithoutSeconds(new Date(value.timeValue)) :
  value.numberValue !== undefined ? Formatters.formatFloat(value.numberValue) :
  value.boolValue !== undefined ? value.boolValue ? 'True' : 'False' :
  'Null'
);

const compareValues = (a: DataRoleSingleValue, b: DataRoleSingleValue) => (
  a.stringValue ? a.stringValue.localeCompare(b.stringValue) :
  a.timeValue ? a.timeValue - b.timeValue :
  a.numberValue ? a.numberValue - b.numberValue:
  a.boolValue ? a && 1 : 0
);
